/**
 * Normalise UK mobile input (spaces, +44, leading 0) to 10-digit format stored in DB (7xxxxxxxxx).
 * @returns {string|null}
 */
export function normalizeUkMobile(input) {
  if (input === null || input === undefined) return null;

  let clean = String(input).replace(/\D/g, '');

  if (clean.startsWith('44') && clean.length >= 12) {
    clean = clean.slice(2);
  }

  if (clean.length === 11 && clean.startsWith('0')) {
    clean = clean.slice(1);
  }

  if (clean.length === 10 && clean.startsWith('7')) {
    return clean;
  }

  return null;
}

export function validateUkMobile(input) {
  return normalizeUkMobile(input) !== null;
}

/** True for empty, all-zero, or academy placeholder numbers that must not match real players or trigger SMS. */
export function isPlaceholderMobile(input) {
  const digits = String(input || '').replace(/\D/g, '');
  return digits === '' || /^0+$/.test(digits);
}
